module.exports = __webpack_public_path__ + "img/空气桥-尺寸.224a589e.svg";